import { render } from "./EventOrganizerInfoModal.vue?vue&type=template&id=d3764cdc&scoped=true"
import script from "./EventOrganizerInfoModal.vue?vue&type=script&lang=js"
export * from "./EventOrganizerInfoModal.vue?vue&type=script&lang=js"

import "./EventOrganizerInfoModal.vue?vue&type=style&index=0&id=d3764cdc&lang=css&scoped=true"

import exportComponent from "/var/www/test.mciafc.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3764cdc"]])

export default __exports__